import { EAPFeature } from '.';
import replacement from '../../../services/Replacement';

export const features: EAPFeature[] = [
    {
        id: 'reviews-cross-cycle-reporting',
        name: 'Cross-Cycle Reporting',
        description: <>Report on average ratings across Review Cycles, or track progress in parallel Cycles</>,
        descriptionLong: (
            <>
                <p>
                    Using the Cycle picker dropdown, you can now load data from several Review Cycles to compare them.
                    For instance, you can group by department and subgroup by Cycle to see how rating averages have
                    evolved.
                </p>
                <p>
                    And if you conduct multiple Cycles in parallel, you can now report on progress across all Reviews in
                    those Cycles.
                </p>
            </>
        ),
        type: 'preview',
        featureToggle: 'FEATURE_reviewCrossCycleReporting',
        imgSrc: require('./images/reviews-cross-cycle-reporting.png'),
    },
    {
        id: 'ai-coaching-objectives',
        name: 'Objectives AI Coach',
        description: 'Help your staff create better Objectives, with some AI help',
        descriptionLong: (
            <>
                <p>
                    Writing and assessing objectives can be hard. Our upcoming AI coach offers assistance, nudging the
                    creator in the right direction and showing the manager ways to improve the objective.
                </p>
                <p>You’ll find the Objectives Coach underneath each Objective.</p>
            </>
        ),
        type: 'preview',
        featureToggle: 'FEATURE_objectivesCoach',
    },
    {
        id: 'inbox',
        name: 'Inbox',
        description: 'Never miss notifications anymore thanks to the new Inbox',
        descriptionLong: (
            <>
                <p>
                    Notifications deserve a proper place on the main menu so that users can interact with the content
                    immediately. Your manager left a comment on your objective? Take note and reply right away.
                </p>
                <p>
                    Try our clickable prototype for 1:1s and Objectives, and let us know what’s important to you and
                    your employees.
                </p>
            </>
        ),
        type: 'preview',
        featureToggle: 'FEATURE_inboxPage',
        imgSrc: require('./images/inbox.png'),
    },
    {
        id: 'new-admin-navigation',
        name: 'Easy Admin Navigation',
        description: 'We’ll make it easier to reach all admin screens, removing the need for the "Admin Toggle Button"',
        descriptionLong: (
            <>
                <p>
                    Many customers told us that toggling the navigation from “employee” to “admin” causes too much
                    friction. We plan on removing the toggle, adding administration tabs into the feature tabs.
                </p>
                <p>
                    Take a look at the clickable Figma Prototype, and let us know if you foresee any challenges or
                    downsides.
                </p>
            </>
        ),
        type: 'clickablePrototype',
        link: 'https://www.figma.com/proto/WHLU0TF4oAtnfsRhVHOVam/consolidated-admin-screens?page-id=120%3A2622&node-id=120-2650&viewport=740%2C174%2C0.21&t=3QoxmulcsliJEQMm-1&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=120%3A2650',
        imgSrc: require('./images/new-admin-navigation.png'),
    },
    {
        id: 'review-cycle-summary',
        name: 'AI Review Cycle Summary',
        description: 'Discover common topics and sentiments in your review cycles with AI-powered analysis.',
        descriptionLong: (
            <>
                <p>
                    Tired of sifting through endless {replacement('pr.plural.short')} for insights and trends? Our new
                    AI Summary Tab surfaces the big takeaways instantly — no exports, no spreadsheets, just clarity.
                </p>
                <p>Try it in your {replacement('pr.singular.short')} dashboard.</p>
            </>
        ),
        type: 'preview',
        featureToggle: 'FEATURE_reviewCycleSummary',
        imgSrc: require('./images/review-cycle-summaries.png'),
    },
];
